import { Navigate, Route, Routes } from 'react-router-dom'
import DispatcherBidsPage from './DispatcherBidsPage'

export default function DispatcherBidsRoutes() {
    return (
        <Routes>
            <Route index element={<DispatcherBidsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
